// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__24_1C","errors":"Errors_errors__YgeBa"};